import { useCallback } from 'react';

export const useTracking = () => {
  const trackPurchase = useCallback((orderData) => {
    if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {
      window.gtag('event', 'purchase', {
        transaction_id: orderData.id,
        value: orderData.total,
        currency: 'ARS',
        items: orderData.items.map(item => ({
          item_id: item.id,
          item_name: item.name,
          category: 'Pelotas',
          quantity: item.quantity,
          price: item.price
        }))
      });
    }
  }, []);

  const trackAddToCart = useCallback((product) => {
    if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {
      window.gtag('event', 'add_to_cart', {
        currency: 'ARS',
        value: product.price * product.quantity,
        items: [{
          item_id: product.id,
          item_name: product.name,
          category: 'Pelotas',
          quantity: product.quantity,
          price: product.price
        }]
      });
    }
  }, []);

  const trackLead = useCallback(() => {
    if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {
      window.gtag('event', 'generate_lead', {
        currency: 'ARS',
        value: 1000
      });
    }
  }, []);

  const trackViewItem = useCallback((product) => {
    if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {
      window.gtag('event', 'view_item', {
        currency: 'ARS',
        value: product.price,
        items: [{
          item_id: product.id,
          item_name: product.name,
          category: 'Pelotas'
        }]
      });
    }
  }, []);

  const trackBeginCheckout = useCallback((cartData) => {
    if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {
      window.gtag('event', 'begin_checkout', {
        currency: 'ARS',
        value: cartData.total,
        items: cartData.items.map(item => ({
          item_id: item.id,
          item_name: item.name,
          category: 'Pelotas',
          quantity: item.quantity,
          price: item.price
        }))
      });
    }
  }, []);

  return {
    trackPurchase,
    trackAddToCart,
    trackLead,
    trackViewItem,
    trackBeginCheckout
  };
}; 